import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { Divider } from 'antd'

import { logout } from '../../containers/Authentication/services'
import { userLogout } from '../../containers/Authentication/actions'
import { handleError } from '../../helpers'

export default function MainMenu({ closeMenu }) {
	const user = useSelector(state => state.auth.user)
	const dispatch = useDispatch()

	const onLogout = () => {
		logout()
			.then(() => dispatch(userLogout()))
			.catch(handleError)
	}

	return (
		<React.Fragment>
			<Container>
				<UserContainer>
					<UserIcon>
						<FontAwesomeIcon icon={faUser} />
					</UserIcon>
					<UserName>{user.fullname}</UserName>
					<p>c.c. {user.document}</p>
					<p className="mb-0 text-link" onClick={onLogout}>Cerrar Sesión</p>
				</UserContainer>
				<MenuList>
					<li><Link to="/home" onClick={closeMenu}>Página Principal</Link></li>
					<Divider className='mt-3 mb-0' />
					<li><Link to="/coupons" onClick={closeMenu}>Ver mis cupos</Link></li>
					<li><Link to="/coupon_orders/new" onClick={closeMenu}>Solicitar uso de cupo</Link></li>
					<li><Link to="/coupon_orders" onClick={closeMenu}>Ver mis solicitudes</Link></li>
					<li><Link to="/order_invoices/coupons" onClick={closeMenu}>Ver mis compras con cupos</Link></li>
					<Divider className='mt-3 mb-0' />
					<li><Link to="/incentives" onClick={closeMenu}>Ver incentivos para referidos</Link></li>
					<li><Link to="/referral_orders/new" onClick={closeMenu}>Enviar incentivo a referido</Link></li>
					<li><Link to="/referral_orders" onClick={closeMenu}>Ver incentivos enviados</Link></li>
					<li><Link to="/order_invoices/referrals" onClick={closeMenu}>Ver compras de referidos</Link></li>
					<Divider className='mt-3 mb-0' />
					<li><Link to="/employees/points" onClick={closeMenu}>Consultar puntos acumulados</Link></li>
					<li><Link to="/rewards" onClick={closeMenu}>Catálogo de premios con puntos</Link></li>
					<li><Link to="/employee_rewards" onClick={closeMenu}>Ver mis premios redimidos</Link></li>
					<Divider className='mt-3 mb-0' />
					<li><Link to="/product_rates" onClick={closeMenu}>Listado de tarifas empleado</Link></li>
				</MenuList>
				<p>Correo de soporte: soporte@smart4.com.co</p>
			</Container>
		</React.Fragment>
	)
}

const Container = styled.div`
	position: fixed;
	top: 0px;
	left: 0px;
	height: 100vh;
	z-index: 9;	
	padding-top: 50px;
	width: 280px;
	background-color: white;
	text-align: center;
	-webkit-box-shadow: 3px 0 12px 0 #b3b3b3;
	box-shadow: 3px 0 12px 0 #b3b3b3;
	overflow-y: scroll;
`

const UserContainer = styled.div`
	padding: 40px 20px 30px;
	background-color: #e8e8e8;
`

const UserName = styled.h6`
	font-size: 17px;
	text-transform: uppercase;
	font-weight: 600;
`

const UserIcon = styled.div`
	height: 4.2rem;
	width: 4.2rem;
	font-size: 1.9rem;
	background: #f8f8f8;
	border: 4px solid #fff;
	border-radius: 50%;
	color: #e0e0e0;
	margin: 0px auto 15px;
	padding-top: 8px;
`

const MenuList = styled.ul`
	list-style: none;
	margin: 0px 0px 30px;
	padding: 0;
	& li {
		padding: 0;
    	margin: 0;
	}
	& li a {
		display: inline-block;
		padding: 14px 0;
		margin: 0;
		border-bottom: 1px solid #e8e8e8;
		width: 100%;
	}
	& li a:hover {
		cursor: pointer;
		background-color: #333;
		color: #fff !important;
	}
`